// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__SLPQ8","header":"ClearentDisclaimer_header__1t98d","inner":"ClearentDisclaimer_inner__HYzTO"};